import { lazy } from "react";
import type { ComponentType } from "react";

import PaymentCanceled from "app/components/pages/Payment/PaymentCanceled/PaymentCanceled";

const PayPage = lazy(() => import("app/pages/pay/PayPage"));
const NotFound = lazy(() => import("app/components/pages/NotFound/NotFound"));
const PaymentPending = lazy(() => import("app/components/pages/Payment/PaymentPending/PaymentPending"));
const PaymentSuccess = lazy(() => import("app/components/pages/Payment/PaymentSuccess/PaymentSuccess"));
const PaymentFailure = lazy(() => import("app/components/pages/Payment/PaymentFailure/PaymentFailure"));

export const routes = {
  pay: "/",
  pendingPayment: "/payment-pending",
  success: "/payment-success",
  failure: "/payment-failure",
  expired: "/payment-expired",
  canceled: "/payment-canceled",
  notFound: "/not-found",
} as const;

export const routeConfig: Record<string, { path: string; component: ComponentType<any> }> = {
  pay: {
    path: routes.pay,
    component: PayPage,
  },
  pendingPayment: {
    path: routes.pendingPayment,
    component: PaymentPending,
  },
  success: {
    path: routes.success,
    component: PaymentSuccess,
  },
  failure: {
    path: routes.failure,
    component: PaymentFailure,
  },
  canceled: {
    path: routes.canceled,
    component: PaymentCanceled,
  },
  expired: {
    path: routes.expired,
    component: PaymentCanceled,
  },
  notFound: {
    path: "*",
    component: NotFound,
  },
};
